<template>
  <el-container>
    <el-header style="height: 70px;background-color: #FFFFFF">
      <div class="header-info">
        <img class="header-logo" src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/logo-s.png">
        <a class="company-name">广东良方药业有限公司</a>
        <div class="info-navi">
          <ul>
<!--            <li>-->
<!--              <el-link class="navi-link" href="/hy-mic-sy/home" :underline="false">首页</el-link>-->
<!--            </li>-->
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/news" :underline="false">行业资讯</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/about" :underline="false">关于我们</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/contactUs" :underline="false">联系我们</el-link>
            </li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-main>
      <div class="product-details">
        <div class="show-img">
          <div class="main-img">
            <img :src="product.img">
          </div>
          <div class="img-menu">
            <img :src="product.img">
          </div>
          <div class="product-detail-tips" style="text-align: left">
            <span style="color: rgb(255, 162, 0);height: 100px;width:30px;display: inline;font-size: 12px">
              温馨提示：
            </span>
            <span style="float: right;width: 330px;font-size: 12px;padding-top: 5px;color: #707070;line-height: 14px">
              图片均为原品的真实拍摄，仅供参考。 如遇新包装上市可能存在上新滞后，请以实物为准。
            </span>
          </div>
        </div>
        <div class="detail">
          <div class="title-icon">
            <span class="icon">自营</span>
            <span class="title">{{ product.title1 }}</span>
          </div>
          <div class="info">
            <p>
              <span class="info-title">生产厂家：</span>
              <span class="info-value">{{ product.manufacturer }}</span>
            </p>
            <p>
              <span class="info-title">批准文号：</span>
              <span class="info-value">{{ product.approvalNumber }}</span>
            </p>
            <p>
              <span class="info-title">规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：</span>
              <span class="info-value">{{ product.title2 }}</span>
            </p>
            <p>
              <span class="info-title">包装规格：</span>
              <span class="info-value">{{ product.packingSpecification }}</span>
              <!--              <span style="display: inline-block;margin-left: 80px;">不可拆分</span>-->
            </p>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer style="height: 70px;padding-top: 40px">
      <div class="footer-info">
        <p style="line-height: 25px">
          版权所有©广东良方药业有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/xinxizheng.jpg" target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2020-0099
          </a> <br>
          ICP主体备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2022011696号-1
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/yinyezhizhao.jpg" target="_blank">营业执照副本</a>
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import Login from "@/views/login/LoginApp";

export default {
  data() {
    component:{
      Login
    }
    return {
      queryId: 0,
      productData: [{
        id: 1,
        title1: '清热祛湿颗粒(众生)',
        title2: '10g*20袋/包*50包/件',
        img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file18031561622515442.jpg',
        manufacturer: '广东众生药业股份有限公司',
        approvalNumber: '国药准字Z44023763',
        packingSpecification: '1包',
        unit: '袋'
      }, {
        id: 2,
        title1: '小柴胡颗粒',
        title2: '10g*10袋/盒*100盒/件',
        img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/filechc5hKxRZQ.png-ly.jpg',
        manufacturer: '广州白云山光华制药股份有限公司',
        approvalNumber: '国药准字Z44020211',
        packingSpecification: '1盒',
        unit: '盒'
      },
        {
          id: 3,
          title1: '京制牛黄解毒片',
          title2: '8片/瓶*10瓶/盒*120盒/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file4TCtkMYHBH.jpg',
          manufacturer: '北京同仁堂科技发展股份有限公司制药厂',
          approvalNumber: '国药准字Z11020472',
          packingSpecification: '1盒',
          unit: '盒'
        },
        {
          id: 4,
          title1: '清开灵口服液',
          title2: '10ml*6支/盒*100盒/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/filef68Q6SFzEW.jpg-ly.jpg',
          manufacturer: '广州白云山明兴制药有限公司',
          approvalNumber: '国药准字Z10880028',
          packingSpecification: '1盒',
          unit: '盒'
        },
        {
          id: 5,
          title1: '感冒灵颗粒',
          title2: '10克/袋*9袋/盒*120盒/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileaJjGRdPPAE.jpg',
          manufacturer: '广东新峰药业股份有限公司',
          approvalNumber: '国药准字Z44021019',
          packingSpecification: '1盒',
          unit: '盒'
        },
        {
          id: 6,
          title1: '小儿七星茶颗粒',
          title2: '7g*10袋*120盒/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file86881561623365639.jpg',
          manufacturer: '广州王老吉药业股份有限公司',
          approvalNumber: '国药准字Z44023698',
          packingSpecification: '1盒',
          unit: '盒'
        }, {
          id: 7,
          title1: '蛇胆川贝液',
          title2: '10ml/支*8支/盒*120盒/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileEXnQAmSiaP.jpg',
          manufacturer: '湖北济安堂药业股份有限公司',
          approvalNumber: '国药准字Z42020095',
          packingSpecification: '1盒',
          unit: '盒'
        }, {
          id: 8,
          title1: '壮腰健肾丸',
          title2: '35克/瓶*200瓶/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file50051561622581425.jpg',
          manufacturer: '广州白云山陈李济药厂有限公司',
          approvalNumber: '国药准字Z44021061',
          packingSpecification: '1瓶',
          unit: '瓶'
        }, {
          id: 9,
          title1: '强力枇杷露',
          title2: '200ml/瓶*60瓶/件',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileAwYfTNpYX6.jpg',
          manufacturer: '合肥今越制药有限公司',
          approvalNumber: '国药准字Z34020452',
          packingSpecification: '1瓶',
          unit: '瓶'
        }, {
          id: 10,
          title1: '消炎镇痛膏',
          title2: '4cm*6cm*10贴*300盒',
          img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileN58jz3FTYz.jpg',
          manufacturer: '广州白云山医药集团股份有限公司白云山何济公制药厂',
          approvalNumber: '国药准字Z44023763',
          packingSpecification: '1包',
          unit: '盒'
        }],
      product: {
        id: 1,
        title1: '清热祛湿颗粒(众生)',
        title2: '10g*20袋/包*50包/件',
        img: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file18031561622515442.jpg',
        manufacturer: '广东众生药业股份有限公司',
        approvalNumber: '国药准字Z44023763',
        packingSpecification: '1包',
        unit: '袋'
      },
      activeName: 'first',
      banners: [
        {
          name: 'banner1',
          url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.616pic.com%2Fbg_w1180%2F00%2F03%2F29%2Fzu3L5I3Cah.jpg&refer=http%3A%2F%2Fpic.616pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668217410&t=cbaa27bda78de8cea75e03b8080e3dc9'
        }
      ],
      itemBanners: [
        {name: 'banner1', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file24FDEkGnat.jpg'},
        {name: 'banner2', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileD5pHJsc8at.jpg'},
        {name: 'banner3', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileDDwnrtifzD.jpg'}
      ]
    }
  },
  created() {
    this.initPage(this.$route.query.id)
  },
  methods: {
    initPage(id) {
      let index = id - 1
      this.product = this.productData[index]
    }
  }
}
</script>

<style>
.info-title {
  color: #999999;
  font-size: 24px;
  height: 60px;
  display: inline-block;
}

.detail .info {
  width: 540px;
  height: 145px;
  padding: 8px 0px 24px;
  font-size: 24px;
  text-align: left;
  margin-top: 20px;
}

.title-icon .title {
  font-size: 28px;
  font-weight: 600;
  margin-left: 10px;
}

.title-icon .icon {
  width: 36px;
  height: 20px;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
  display: inline-block;
  background-color: #2cb251;
}

.title-icon {
  text-align: left;
}

.detail {
  width: 580px;
  height: 500px;
  padding-left: 40px;
  float: left;
}

.product-detail-tips {
  height: 100px;
}

.img-menu img {
  width: 56px;
  height: 56px;
  border: 2px solid black;
}

.img-menu {
  height: 60px;
  margin-top: 20px;
}

.main-img img {
  width: 400px;
  height: 400px;
  border: 1px solid #DDDDDD;
}

.main-img {
  width: 400px;
}

.show-img {
  width: 400px;
  height: 580px;
  float: left;
}

.product-details {
  width: 1200px;
  height: 604px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #dddddd;
}

.el-main {
  margin: 0 auto;
}

.about-us-profile h3 {
  font-weight: 600;
}

.about-us img {
  border-radius: 6px;
  width: 520px;
  height: 350px;
  float: left;
}

.product-img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.content-tiny-program-info span {
  display: inline-block;
  margin-left: 10px;
  font-size: 18px;
}

.content-tiny-program-info img {
  height: 25px;
  width: 25px;
  line-height: 30px;
}


.second-banner img {
  width: 700px;
  height: 350px;
}

.footer-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}

.el-link {
  font-size: 18px;
}

ul {
  display: flex;
  list-style: none;
  padding: 0;
  line-height: 40px;
  height: 70px;
  float: right;
  margin-right: 50px;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 40px;
  line-height: 70px;
}

.info-navi {
  float: right;
  width: 750px;
  height: 70px;
  text-align: right;
}

.main-banner {
}

.el-header, .el-footer {
  color: #333;
  text-align: left;
  line-height: 70px;
  height: 70px;
}

.header-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  /*border-bottom: 1px solid #DDDDDD;*/
}

.header-logo {
  width: 65px;
  height: 65px;
  float: left;
}

.header-info .company-name {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
</style>
<style scoped>

</style>
